wbApp.directive('wbFranchiseCentralSubjectsCombo', ['$timeout', '$translate', 'subjectsSvc',
    function ($timeout, $translate, subjectsSvc) {
        function formatResult(subject) {
            if (!subject) { return; }

            return subject.name;

            //return "<div class='row'>" +
            //            "<div class='col-md-4'>" + subject.name + "</div>" +
            //            "<div class='col-md-8'>" + subject.description || '' + "</div>" +
            //        "</div>";
        }

        function formatSelection(subject) {
            return subject.name;
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            replace: true,
            scope: {
                franchiseCentralTenantId: '=',
            },
            link: function (scope, elm, attrs, ctrl) {

                
                var subjects = !!scope.franchiseCentralTenantId
                    ? subjectsSvc.getAllFranchiseCentralCourseSubjects(scope.franchiseCentralTenantId, true)
                    : [];

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_FRANCHISE_CENTRAL_SUBJECT'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: true,
                        minimumResultsForSearch: -1,
                        id: function (subject) { return subject.id; },
                        data: subjects
                    });

                    ctrl.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return 0;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    ctrl.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    ctrl.$render = function () {
                        if (subjects.$promise) {
                            subjects.$promise.then(function () {
                                $(elm).select2('val', ctrl.$viewValue);
                            });
                        }
                    }

                    scope.$watch('franchiseCentralTenantId', function (newValue) {
                        if (!newValue) {
                            subjects.length = 0;
                            return;
                        }
                        var newSubjects = subjectsSvc.getAllFranchiseCentralCourseSubjects(newValue);
                        newSubjects.$promise.then(function () {
                            if (newSubjects !== subjects) {
                                subjects.length = 0;
                                subjects.push.apply(subjects, newSubjects);
                            }

                            for (var i = 0; i < subjects.length; i++) {
                                if (subjects[i].id == ctrl.$viewValue) {
                                    $(elm).select2('val', subjects[i].id);
                                    return;
                                }
                            }

                            $(elm).select2('val', null);
                            ctrl.$setViewValue(null);
                        });
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                }, 1);
            }
        }
    }]);